import * as $ from 'jquery';

export class PressReleaseCommon {
    static init() {
        $(document).off('click','.press-release-download-all'),
        $(document).on('click','.press-release-download-all', ev => $(ev.target).closest('.press-release-download-all').toggleClass('selected'))
    }

    //private static downloadAll(ev) {
        //$(ev.target).closest('.extra.sheets').find('a[href]').each((i, a) =>
        //      a.click()
        //     );
    
    //}
}